import React, { Component } from 'react';
import './WorksPanel.css';
import WorkBlock from './WorkBlock';

export const id = 'workpanel';

class WorksPanel extends Component {
  render() {
    const workPanelContainerClassname = this.props.isMobile ?
      'MobileWorkContainer' :
      'WorkContainer';

    return (
      <div className="WorksPanel" id={id}>
        <div className="WorksPanelBlurb">
          <div id="WorkContainer" className={workPanelContainerClassname}>
            <h2>Where I have worked and studied?</h2>
            <WorkBlock
              title='Lead Software Engineer'
              company='Appian Corporation'
              companyUrl='https://www.appian.com'
              startDate='December 2015'
              endDate='current'
              location='Reston, VA, USA'
              backgroundColor='#FFFFFF'
            >
              Full-time Software Engineer dedicated to the success of the web and mobile clients for <a href="https://www.appian.com">Appian's Software Platform Service</a>.
            </WorkBlock>
            <WorkBlock
              title='Manager, Software Development, End User Mobile team'
              company='Appian Corporation'
              companyUrl='https://www.appian.com'
              startDate='October 2013'
              endDate='November 2015'
              location='Reston, VA, USA'
              backgroundColor='#EEEEEE'
            >
              Responsible for the Agile software processes, technical oversight and contributions, and management of the Appian <a href="https://itunes.apple.com/us/app/appian/id417065205?mt=8">iOS</a> and <a href="https://play.google.com/store/apps/details?id=com.appian.android">Android</a> Software Engineers.
            </WorkBlock>
            <WorkBlock
              title='Manager, Platforms Software Development Team'
              company='Nemetschek Vectorworks'
              companyUrl='http://www.vectorworks.net'
              startDate='September 2008'
              endDate='October 2013'
              location='Columbia, MD, USA'
              backgroundColor='#FFFFFF'
            >
              Responsible for the generation of project ideas, design, leadership, documentation, and implementation of software projects for <a href="http://www.vectorworks.net">Vectorworks</a> for the Apple Macintosh and Microsoft Windows Operating Systems.
            </WorkBlock>
            <WorkBlock
              title='Scrum Master and Software Engineer, Vectorworks Cloud Services Software Team'
              company='Nemetschek Vectorworks'
              companyUrl='http://www.vectorworks.net'
              startDate='May 2011'
              endDate='April 2012'
              location='Columbia, MD, USA'
              backgroundColor='#EEEEEE'
            >
              While working as Manager for the Platforms Software Development Team, took care of the Agile Scrum process and web server front-end and back-end development for <a href="http://www.vectorworks.net">Vectorworks'</a> first <a href="https://cloud.vectorworks.net/accounts/login/?next=/portal/files/">foray into Cloud and Mobile</a> development.
            </WorkBlock>
            <WorkBlock
              title='Software Engineer, Platforms Software Development Team'
              company='Nemetschek Vectorworks'
              companyUrl='http://www.vectorworks.net'
              startDate='March 2001'
              endDate='August 2008'
              location='Columbia, MD, USA'
              backgroundColor='#FFFFFF'
            >
              Responsible for the generation of project ideas, design, documentation and implementation of software projects for <a href="http://www.vectorworks.net">Vectorworks</a> for the Apple Macintosh and Microsoft Windows Operating Systems.
            </WorkBlock>
            <WorkBlock
              title='Software Engineer, Integrated Practices Software Team'
              company='Nemetschek Vectorworks (was Diehl Graphsoft Inc.)'
              companyUrl='http://www.vectorworks.net'
              startDate='January 1999'
              endDate='Februrary 2001'
              location='Columbia, MD, USA'
              backgroundColor='#EEEEEE'
            >
              Designed and developed software modules to be used with <a href="http://www.vectorworks.net">Vectorworks</a> for the Integrated Practices Software team using Nemetschek’s Pascal-like language, <a href="http://developer.vectorworks.net/index.php/VectorScript">VectorScript</a>.
            </WorkBlock>
            <WorkBlock
              title='Programmer Analyst, Department of Consulting and Development'
              company='University of Saskatchewan'
              companyUrl='https://www.usask.ca/ict/index.php'
              startDate='January 1996'
              endDate='Februrary 1998'
              location='Saskatoon, SK, Canada'
              backgroundColor='#FFFFFF'
              showDivider={false}
            >
              After graduating with a Bachelors of Computational Science (1995), from the University of Saskatchewan, Canada, I joined the Department of Consulting and Development at the University.
              
              As a Programmer Analyst for the University's department of Consulting and Development, I was contracted out to the following departments:
              <ol>
                <li>Anatomy and Cell Biology: developed Macintosh and web applications</li>
                <li>Nursing: developed Microsoft Access applications</li>
                <li>Engineering: developed command line print management utilities</li>
              </ol>
            </WorkBlock>
          </div>
        </div>
      </div>
    );
  }
}

export default WorksPanel;



// WEBPACK FOOTER //
// ./src/WorksPanel.js